// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// local
// view
import CustomDropdown from 'app/ui/commons/CustomDropdown';
// api
import * as PatientApi from 'app/api/patient';
// consts
import { STATUS as PATIENT_STATUS } from 'salvus-shared/consts/patient';
// libs
import { sortString } from 'app/lib/helper';

class DropdownPatient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            options: [],
        };
    }

    componentDidMount() {
        PatientApi.list()
            .then(this.onLoadPatientSuccess)
            .catch(this.onLoadPatientFail);
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadPatientSuccess = result => {
        const filter = p => this.props.filter.includes(p.status) && this.props.filterFn(p);
        const patients = result.filter(p => filter(p)).map(patient => ({
            text: patient.name,
            value: patient.id,
        }));
        const currentPatient = this.props.patient && this.props.patient.id ? this.props.patient : null;
        if (currentPatient && !patients.find(p => p.value === currentPatient.id)) {
            patients.push({
                text: currentPatient.name,
                value: currentPatient.id,
            });
        }
        patients.sort((a, b) => sortString(a.text, b.text));
        const options = [{ text: '-', value: null }].concat(patients);
        if (this._isMounted) {
            this.setState({
                loading: false,
                options,
            });
        }
    };

    onLoadPatientFail = () => {
        if (this._isMounted) {
            this.setState({
                loading: false,
                options: [],
            });
        }
    };

    render() {
        const { options, loading } = this.state;
        let { value, onChange, label, placeholder, width, isForm, error } = this.props;
        placeholder = placeholder !== null ? placeholder : null;
        label = label !== null ? label : null;
        width = width !== null ? width : null;
        return (
            <CustomDropdown
                selection
                isForm={isForm}
                placeholder={placeholder}
                label={label}
                width={width}
                loading={loading}
                options={options}
                value={value}
                onChange={onChange}
                error={error}
            />
        );
    }
}

DropdownPatient.defaultProps = {
    filter: [PATIENT_STATUS.NEW, PATIENT_STATUS.INITIALIZED, PATIENT_STATUS.DEACTIVATED],
    filterFn: () => true,
};

DropdownPatient.propTypes = {
    value: PropTypes.number,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    width: PropTypes.number,
    isForm: PropTypes.bool,
    onChange: PropTypes.func,
    filter: PropTypes.array,
    filterFn: PropTypes.func,
    patient: PropTypes.object,
    error: PropTypes.bool,
};

export default DropdownPatient;
